import React from "react";
import PropTypes from "prop-types";

const Btn = ({ onClick, btnRef, btnClassName, label }) => {

  return (
    <div 
      className={btnClassName}
      ref={btnRef}
      onMouseOver={() => window.sounds.buttonHover.play()} 
      onClick={() => onClick()}
      >
      {label}
    </div>
  );
};

Btn.propTypes = {
  onClick: PropTypes.func.isRequired,
  btnRef: PropTypes.object,
  btnClassName: PropTypes.string,
  label: PropTypes.string
};

export default Btn;



// WEBPACK FOOTER //
// ./src/js/components/buttons/Btn.jsx